function CardSlabForm() {
  const handleTextChange = (e) => {
    e.preventDefault()
    console.log(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <div className='container mx-auto'>
      <form onSubmit={handleSubmit}>
        <div className='flex flex-col mb-8 mt-8'>
          <div className='w-full md:w-5/6 md:mx-auto'>
            <h1 className='text-2xl text-gray-600 text-center lg:text-justify leading-loose my-6'>
              Enter Slab Inventory Details Here
            </h1>
          </div>
          <div className='w-full md:mx-auto m-2 p-6 bg-white border border-solid border-gray-300 rounded-xl md:w-5/6'>
            <label htmlFor='colorInput' className='form-control my-2'>
              Color
            </label>
            <input
              onChange={handleTextChange}
              type='text'
              id='colorInput'
              placeholder='Name of Color Here'
              required
              className='form-control block w-full md:w-1/2 px-3 py-1.5 text-base font-normal text-gray-600 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
            />

            <label htmlFor='brandInput' className='form-control my-2'>
              Brand
            </label>
            <input
              onChange={handleTextChange}
              type='text'
              id='brandInput'
              placeholder='Brand of Quartz'
              required
              className='form-control block w-full md:w-1/2 px-3 py-1.5 text-base font-normal text-gray-600 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
            />

            <label htmlFor='thicknessInput' className='form-control my-2'>
              Thickness
            </label>
            <select
              onChange={handleTextChange}
              id='thicknessInput'
              required
              defaultValue={'DEFAULT'}
              className='form-select block w-full md:w-1/2 px-3 py-1.5 text-base font-normal text-gray-600 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
            >
              <option value='DEFAULT' disabled>
                Select Thickness
              </option>
              <option value='1'>2cm</option>
              <option value='2'>3cm</option>
            </select>

            <label htmlFor='finishInput' className='form-control my-2'>
              Finish
            </label>
            <select
              onChange={handleTextChange}
              id='finishInput'
              required
              defaultValue={'DEFAULT'}
              className='form-select w-full md:w-1/2 block px-3 py-1.5 text-base font-normal text-gray-600 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 mb-8 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
            >
              <option value='DEFAULT' disabled>
                Select Finish
              </option>
              <option value='1'>Polished</option>
              <option value='2'>Honed</option>
              <option value='3'>Matte</option>
              <option value='4'>Concrete</option>
              <option value='5'>Leather</option>
              <option value='6'>Natural</option>
            </select>

            <button
              type='submit'
              className='w-full md:w-1/4 inline-block border-2 mx-auto rounded-2xl border-blue-500 p-3 text-blue-600 text-center text-lg shadow-lg hover:bg-blue-600 hover:text-white active:scale-95 transition duration-200 ease-in-out'
            >
              Update Inventory
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CardSlabForm
